import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccreditationRequestDetailsService } from 'src/app/features/cabs/modules/accreditation-requests/services/accreditation-request-details.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-digital-signature-confirmation',
  templateUrl: './digital-signature-confirmation.component.html',
  styles: [
  ]
})
export class DigitalSignatureConfirmationComponent implements OnInit {
  @ViewChild('customTemplate', { static: true }) customTemplate!: TemplateRef<any>;
  file: any;
  successMessage: any;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private service: AccreditationRequestDetailsService,
    public toastr: ToastrService) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      console.log(params);
      let status = params.get('status');
      let signer_process_id = params.get('signer_process_id');
      this.confirmDigitalSignature(status, signer_process_id);
    });
  }

  confirmDigitalSignature(status: string, signer_process_id: string) {
    let model = { status: status, signer_process_id: signer_process_id };
    this.service.digitalSignatureConfrim(model).subscribe(
      response => {
        if (response.status != "succsess") {
          this.showError("User cancelled the signing process");
        } else {
          this.file = response.file;
          this.successMessage = response.message;
          const success = document.getElementById('DigitalAggrementSuccessMessage');
          Swal.fire({
            title: 'Success',
            html: success,
            icon: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            response?.redirect_url ?
              this.router.navigate([response?.redirect_url]) :
              this.router.navigate(['/'])
          });
        }
      },
      (error) => {
        if (error?.status == "failure") {
          this.showError("User cancelled the signing process");
        } else {
          this.showError(error.message);
        }
        error?.redirect_url ?
          this.router.navigate([error?.redirect_url]) :
          this.router.navigate(['/'])
      }
    )
  }

  showError(msg) {
    this.toastr.error(msg);
  }

  showSuccess(msg) {
    this.toastr.success(msg);
  }

}
